import { useContext, useEffect, useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { AppContext } from '../../../../context';
import { Modal } from '../../BaseModal';
import { TimeAttendanceEventsModalProps } from '../TimeAttendanceEventsModalProps';
import UbicationSelector from '../components/UbicationSelector';
import {
    AssociateTimeAttendanceEvents,
    EventModel,
} from './AssociateTimeAttendanceEvents';

const AssociateMarkingModal = ({
    setModalOpen,
    isOpen,
    employee,
    startDate,
    endDate,
    workshifts,
    saveTimeAttendanceEvents,
}: TimeAttendanceEventsModalProps) => {
    const { langResources } = useContext(AppContext);
    const cachedValues = window.localStorage.getItem('time')
        ? JSON.parse(window.localStorage.getItem('time') ?? '')
        : '';

    const [eventTypeValue, setEventTypeValue] = useState(cachedValues.type ?? '');
    const [markingEntry, setMarkingEntry] = useState<EventModel>({
        eventTypeId: 1,
        hour: cachedValues.hour ?? '',
        observations: '',
        isNextDay: false,
        ubicationId: 0,
    } as EventModel);
    const [markingExit, setMarkingExit] = useState<EventModel>({
        eventTypeId: 2,
        hour: cachedValues.hour ?? '',
        isNextDay: false,
        observations: '',
        ubicationId: 0,
    } as EventModel);

    const [errors, setErrors] = useState('Completa todos los campos');

    const handleCloseModal = () => {
        setMarkingEntry({} as EventModel);
        setMarkingExit({} as EventModel);
        setEventTypeValue('');
        setModalOpen(false);
        window.localStorage.removeItem('time');
    };

    const handleInputChangeEntry = (
        name: string,
        value: string | number | number[] | boolean
    ) => {
        setMarkingEntry({ ...markingEntry, [name]: value });
    };

    const handleInputChangeExit = (
        name: string,
        value: string | number | number[] | boolean
    ) => {
        setMarkingExit({ ...markingExit, [name]: value });
    };

    const handlerSubmit = () => {
        if (startDate && employee) {
            let newMarking: AssociateTimeAttendanceEvents = {
                date: startDate?.toString(),
                employeeId: Number(employee[0].id),
                events: [],
            };

            if (['both', 'workshiftHours'].includes(eventTypeValue)) {
                newMarking.events.push(markingEntry);
                newMarking.events.push(markingExit);
            } else if (['entry'].includes(eventTypeValue)) {
                newMarking.events.push(markingEntry);
            } else if (['exit'].includes(eventTypeValue)) {
                newMarking.events.push(markingExit);
            }

            saveTimeAttendanceEvents(newMarking);
            setModalOpen(false);
        }
    };

    const handlerSetHoursFromWorkshift = () => {
        if (workshifts) {
            let initHour = workshifts[0].startTime.split('T')[1];
            let endHour = workshifts[0].endTime.split('T')[1];

            handleInputChangeEntry('hour', initHour);
            handleInputChangeExit('hour', endHour);
        }
    };

    useEffect(() => {
        if (['both', 'workshiftHours'].includes(eventTypeValue)) {
            if (
                markingEntry.hour?.length == 0 ||
                markingEntry.observations?.length == 0 ||
                markingEntry.ubicationId == 0 ||
                markingExit.hour?.length == 0 ||
                markingExit.observations?.length == 0 ||
                markingExit.ubicationId == 0
            ) {
                setErrors('Completa Todos los campos requeridos ');
            } else {
                setErrors('');
            }
        } else if (eventTypeValue == 'exit') {
            if (
                markingExit.hour?.length == 0 ||
                markingExit.observations?.length == 0 ||
                markingExit.ubicationId == 0
            ) {
                setErrors('Completa Todos los campos de Salida');
            } else {
                setErrors('');
            }
        } else if (eventTypeValue == 'entry') {
            if (
                markingEntry.hour?.length == 0 ||
                markingEntry.observations?.length == 0 ||
                markingEntry.ubicationId == 0
            ) {
                setErrors('Completa Todos los campos de Entrada');
            } else {
                setErrors('');
            }
        }
    }, [markingExit, markingEntry]);

    const handlerChangeEventype = (e: string) => {
        setEventTypeValue(e);
        setErrors('Completa todos los campos requeridos');
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle={langResources['marking.modal']['insert.marking.title']}
            onClose={handleCloseModal}
            onSubmit={handlerSubmit}
            disableSubmit={errors?.length > 0}
        >
            <div className='modal-body text-black border justify-content-center rounded mb-2 row m-2'>
                <div className='row justify-content-center text-center p-0'>
                    <h6 className='text-start'>
                        {langResources['marking.modal']['insert.marking.subtitle']}:
                    </h6>

                    <div className='col  checked-custom'>
                        <input
                            className='form-check-input me-1'
                            type='radio'
                            name='marking-event-type'
                            id='flexRadioDefault1'
                            checked={eventTypeValue === 'entry'}
                            onChange={(e) => handlerChangeEventype(e.target.value)}
                            value={'entry'}
                        />
                        <label
                            className='form-check-label'
                            htmlFor='flexRadioDefault1'
                        >
                            {langResources['marking.modal']['entry']}
                        </label>
                    </div>

                    <div className='col checked-custom'>
                        <input
                            className='form-check-input me-1'
                            type='radio'
                            name='marking-event-type'
                            id='flexRadioDefault2'
                            checked={eventTypeValue === 'exit'}
                            onChange={(e) => handlerChangeEventype(e.target.value)}
                            value={'exit'}
                        />
                        <label
                            className='form-check-label'
                            htmlFor='flexRadioDefault2'
                        >
                            {langResources['marking.modal']['exit']}
                        </label>
                    </div>

                    <div className='col  checked-custom'>
                        <input
                            className='form-check-input me-1'
                            type='radio'
                            name='marking-event-type'
                            id='flexRadioDefault3'
                            checked={eventTypeValue === 'both'}
                            onChange={(e) => handlerChangeEventype(e.target.value)}
                            value={'both'}
                        />
                        <label
                            className='form-check-label'
                            htmlFor='flexRadioDefault3'
                        >
                            {langResources['marking.modal']['both']}
                        </label>
                    </div>

                    {workshifts?.at(0)?.workshiftId && (
                        <div className='col  checked-custom'>
                            <input
                                className='form-check-input me-1'
                                type='radio'
                                name='marking-event-type'
                                id='workshiftHours'
                                checked={eventTypeValue === 'workshiftHours'}
                                onChange={(e) => {
                                    handlerChangeEventype(e.target.value);
                                    handlerSetHoursFromWorkshift();
                                }}
                                value={'workshiftHours'}
                            />
                            <label
                                className='form-check-label'
                                htmlFor='workshiftHours'
                            >
                                {langResources['marking.modal']['workshift']}
                            </label>
                        </div>
                    )}
                </div>

                <div className='row mt-5'>
                    <div className='row'>
                        {(eventTypeValue == 'entry' ||
                            eventTypeValue == 'both' ||
                            eventTypeValue == 'workshiftHours') && (
                            <div
                                className={`col-${
                                    !['both', 'workshiftHours'].includes(
                                        eventTypeValue
                                    )
                                        ? '12 row '
                                        : '6'
                                }`}
                            >
                                <h6 className='text-center'>
                                    {' '}
                                    {langResources['marking.modal']['entry.title']}
                                </h6>

                                <div
                                    className={`col-${
                                        !['both', 'workshiftHours'].includes(
                                            eventTypeValue
                                        )
                                            ? '6'
                                            : '12'
                                    }`}
                                >
                                    <div className='col-12'>
                                        <label
                                            htmlFor='startDate'
                                            className='form-label d-block'
                                        >
                                            {
                                                langResources['marking.modal'][
                                                    'dateHour'
                                                ]
                                            }
                                        </label>
                                        <Flatpickr
                                            className='form-control text-black'
                                            value={markingEntry.hour}
                                            onChange={(e) =>
                                                handleInputChangeEntry(
                                                    'hour',
                                                    e[0].toString().split(' ')[4]
                                                )
                                            }
                                            options={{
                                                enableTime: true,
                                                noCalendar: true,
                                                dateFormat: 'H:i',
                                            }}
                                            disabled={
                                                eventTypeValue == 'workshiftHours'
                                            }
                                        />
                                    </div>

                                    <div className='col-12 mt-2'>
                                        <UbicationSelector
                                            label={
                                                langResources['marking.modal'][
                                                    'ubication'
                                                ]
                                            }
                                            name='ubicationId'
                                            onChange={handleInputChangeEntry}
                                            value={markingEntry.ubicationId}
                                            required={true}
                                        />
                                    </div>
                                </div>

                                <div
                                    className={`mt-2 col-${
                                        !['both', 'workshiftHours'].includes(
                                            eventTypeValue
                                        )
                                            ? '6'
                                            : '12'
                                    }`}
                                >
                                    <label
                                        htmlFor='observations'
                                        className='form-label d-block'
                                    >
                                        {
                                            langResources['marking.modal'][
                                                'observation'
                                            ]
                                        }
                                    </label>
                                    <textarea
                                        onChange={(e) =>
                                            handleInputChangeEntry(
                                                'observations',
                                                e.target.value
                                            )
                                        }
                                        name='observations'
                                        placeholder={
                                            langResources['marking.modal'][
                                                'observation.placeholder'
                                            ]
                                        }
                                        style={{
                                            width: '100%',
                                            height: '78%',
                                            resize: 'none',
                                        }}
                                        className='form-control text-black'
                                        id='observations'
                                    ></textarea>
                                </div>
                                <div className=' checked-custom  mt-2'>
                                    <input
                                        className='form-check-input me-1'
                                        type='checkbox'
                                        name='isNextDay'
                                        id='isNextDay'
                                        checked={markingEntry.isNextDay}
                                        onChange={(e) =>
                                            handleInputChangeEntry(
                                                'isNextDay',
                                                e.target.checked
                                            )
                                        }
                                    />
                                    {langResources['marking.modal']['next.day']}
                                </div>
                            </div>
                        )}

                        {(eventTypeValue == 'exit' ||
                            eventTypeValue == 'both' ||
                            eventTypeValue == 'workshiftHours') && (
                            <div
                                className={`col-${
                                    !['both', 'workshiftHours'].includes(
                                        eventTypeValue
                                    )
                                        ? '12 row '
                                        : '6'
                                }`}
                            >
                                <h6 className='text-center'>
                                    {' '}
                                    {langResources['marking.modal']['exit.title']}
                                </h6>
                                <div
                                    className={`col-${
                                        !['both', 'workshiftHours'].includes(
                                            eventTypeValue
                                        )
                                            ? '6'
                                            : '12'
                                    }`}
                                >
                                    <div className='col'>
                                        <label
                                            htmlFor='startDate'
                                            className='form-label d-block'
                                        >
                                            {
                                                langResources['marking.modal'][
                                                    'dateHour'
                                                ]
                                            }
                                        </label>
                                        <Flatpickr
                                            className='form-control text-black'
                                            value={markingExit.hour}
                                            onChange={(e) =>
                                                handleInputChangeExit(
                                                    'hour',
                                                    e[0].toString().split(' ')[4]
                                                )
                                            }
                                            options={{
                                                enableTime: true,
                                                noCalendar: true,
                                                dateFormat: 'H:i',
                                            }}
                                            disabled={
                                                eventTypeValue == 'workshiftHours'
                                            }
                                        />
                                    </div>

                                    <div className='col-12 mt-2'>
                                        <UbicationSelector
                                            label={
                                                langResources['marking.modal'][
                                                    'ubication'
                                                ]
                                            }
                                            name='ubicationId'
                                            onChange={handleInputChangeExit}
                                            value={markingExit.ubicationId}
                                            required={true}
                                        />
                                    </div>
                                </div>

                                <div
                                    className={`mt-2 col-${
                                        !['both', 'workshiftHours'].includes(
                                            eventTypeValue
                                        )
                                            ? '6'
                                            : '12'
                                    }`}
                                >
                                    <label
                                        htmlFor='observations'
                                        className='form-label d-block'
                                    >
                                        {
                                            langResources['marking.modal'][
                                                'observation'
                                            ]
                                        }
                                    </label>
                                    <textarea
                                        onChange={(e) =>
                                            handleInputChangeExit(
                                                'observations',
                                                e.target.value
                                            )
                                        }
                                        name='observations'
                                        placeholder={
                                            langResources['marking.modal'][
                                                'observation.placeholder'
                                            ]
                                        }
                                        style={{
                                            width: '100%',
                                            height: '80%',
                                            resize: 'none',
                                        }}
                                        className='form-control text-black'
                                        id='observations'
                                    ></textarea>
                                </div>

                                <div className=' checked-custom  mt-2'>
                                    <input
                                        className='form-check-input me-1'
                                        type='checkbox'
                                        name='isNextDay'
                                        id='isNextDay'
                                        checked={markingExit.isNextDay}
                                        onChange={(e) =>
                                            handleInputChangeExit(
                                                'isNextDay',
                                                e.target.checked
                                            )
                                        }
                                    />
                                    {langResources['marking.modal']['next.day']}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <p className='text-danger mt-3'>{errors}</p>
            </div>
        </Modal>
    );
};
export default AssociateMarkingModal;
